import { render, staticRenderFns } from "./allowanceDetail.vue?vue&type=template&id=11ca4d18&"
import script from "./allowanceDetail.vue?vue&type=script&lang=js&"
export * from "./allowanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./allowanceDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports